/**
 * G1 Slider - Lightweight vanilla JS slider for G1 sections
 * @version 1.0.0
 */

class G1Slider {
    constructor(sectionId) {
      this.sectionId = sectionId;
      this.currentIndex = 0;
      this.slides = [];
      this.thumbnails = [];
      this.initialized = false;
      
      // Initialize when DOM is ready
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init());
      } else {
        this.init();
      }
    }
  
    init() {
      // Get elements
      this.wrapper = document.getElementById(`swiper-wrapper-${this.sectionId}`);
      this.slides = document.querySelectorAll(`#product-section-${this.sectionId} .swiper-slide`);
      this.thumbnails = document.querySelectorAll(`#product-section-${this.sectionId} .thumbs_product_image`);
      this.prevBtn = document.querySelector(`#product-section-${this.sectionId} .swiper-button-prev`);
      this.nextBtn = document.querySelector(`#product-section-${this.sectionId} .swiper-button-next`);
      this.thumbsSwiper = document.getElementById(`thumbs-swiper-${this.sectionId}`);
      this.scrollIndicator = document.getElementById(`scroll-indicator-${this.sectionId}`);
  
      if (!this.slides.length) {
        console.warn('G1Slider: No slides found for section', this.sectionId);
        return;
      }
  
      // Set initial state
      this.goToSlide(0);
      this.initialized = true;
  
      // Setup scroll indicator
      if (this.thumbsSwiper && this.scrollIndicator) {
        this.updateScrollIndicator();
        this.thumbsSwiper.addEventListener('scroll', () => this.updateScrollIndicator());
        window.addEventListener('resize', () => {
          setTimeout(() => this.updateScrollIndicator(), 100);
        });
      }
  
      console.log('✅ G1Slider initialized for section:', this.sectionId);
    }
  
    goToSlide(index) {
      if (index < 0 || index >= this.slides.length) return;
      
      this.currentIndex = index;
  
      // Update slides
      this.slides.forEach((slide, i) => {
        if (i === index) {
          slide.classList.add('swiper-slide-active');
        } else {
          slide.classList.remove('swiper-slide-active');
        }
      });
  
      // Update wrapper transform
      if (this.wrapper) {
        const translateX = -index * 100;
        this.wrapper.style.transform = `translateX(${translateX}%)`;
      }
  
      // Update thumbnails
      this.thumbnails.forEach((thumb, i) => {
        if (i === index) {
          thumb.classList.add('active');
        } else {
          thumb.classList.remove('active');
        }
      });
  
      // Scroll thumbnail into view
      if (this.thumbsSwiper && this.thumbnails[index]) {
        const activeThumb = this.thumbnails[index];
        const thumbOffset = activeThumb.offsetLeft;
        const thumbWidth = activeThumb.offsetWidth;
        const swiperWidth = this.thumbsSwiper.offsetWidth;
        
        const scrollPosition = thumbOffset - (swiperWidth / 2) + (thumbWidth / 2);
        this.thumbsSwiper.scrollTo({
          left: scrollPosition,
          behavior: 'smooth'
        });
      }
  
      // Update scroll indicator
      this.updateScrollIndicator();
  
      // Update button states
      if (this.prevBtn) {
        if (index === 0) {
          this.prevBtn.classList.add('swiper-button-disabled');
        } else {
          this.prevBtn.classList.remove('swiper-button-disabled');
        }
      }
      
      if (this.nextBtn) {
        if (index === this.slides.length - 1) {
          this.nextBtn.classList.add('swiper-button-disabled');
        } else {
          this.nextBtn.classList.remove('swiper-button-disabled');
        }
      }
    }
  
    next() {
      if (this.currentIndex < this.slides.length - 1) {
        this.goToSlide(this.currentIndex + 1);
      }
    }
  
    prev() {
      if (this.currentIndex > 0) {
        this.goToSlide(this.currentIndex - 1);
      }
    }
  
    updateScrollIndicator() {
      if (!this.thumbsSwiper || !this.scrollIndicator) return;
  
      const scrollableWidth = this.thumbsSwiper.scrollWidth - this.thumbsSwiper.clientWidth;
      if (scrollableWidth <= 0) {
        this.scrollIndicator.style.width = '100%';
        this.scrollIndicator.style.transform = 'translateX(0)';
        return;
      }
  
      const scrollPercentage = (this.thumbsSwiper.scrollLeft / scrollableWidth) * 100;
      const visiblePercentage = (this.thumbsSwiper.clientWidth / this.thumbsSwiper.scrollWidth) * 100;
      
      this.scrollIndicator.style.width = visiblePercentage + '%';
      this.scrollIndicator.style.transform = `translateX(${scrollPercentage}%)`;
    }
  }
  
  // Export for use in other modules
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = G1Slider;
  }
  
  